<template>
  <div :class="listClasses">
    <component :is="fullStar" :class="elementClasses" />
    <component :is="fullStar" :class="elementClasses" />
    <component :is="fullStar" :class="elementClasses" />
    <component :is="fullStar" :class="elementClasses" />
    <component :is="fullStar" :class="elementClasses" />
  </div>
</template>

<script>
import TrustpilotFull from './svg/TrustpilotFull'
import GradientFull from './svg/GradientFull'

export default {
  components: {
    TrustpilotFull,
    GradientFull
  },

  props: {
    variant: {
      type: String,
      required: true,
      validator: (value) => {
        return ['trustpilot', 'gradient'].includes(value)
      }
    },
    size: {
      type: String,
      default: 'medium'
    }
  },

  computed: {
    fullStar () {
      switch (this.variant) {
        case 'trustpilot':
          return 'TrustpilotFull'
        case 'gradient':
          return 'GradientFull'
        default:
          return null
      }
    },

    listClasses () {
      return ['commonStarsRating', `commonStarsRating_${this.variant}`]
    },

    elementClasses () {
      return [`commonStarsRating_element_${this.size ? this.size : 'medium'}`]
    }
  }
}
</script>

<style lang="scss" scoped>
.commonStarsRating {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;

  &_trustpilot {
    gap: 2px;
  }

  &_element {
    &_medium {
      height: 24px;
      width: 24px;
    }

    &_large {
      height: 32px;
      width: 32px;
    }
  }
}
</style>
